import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cardTitle: {
    defaultMessage: 'Never run out of stock (or oversell)',
    id: '6LWdqN',
    description: 'Title for the undecided inventory card',
  },
  cardDescription: {
    defaultMessage:
      "Inventory tracking shows you exactly what's in stock across all your sales channels. ShipStation updates quantities automatically as you sell, so you always know what you have and avoid disappointing customers.",
    id: 'JVa0If',
    description: 'Description for the undecided inventory card',
  },
  learnMore: {
    defaultMessage: 'Learn more',
    id: 'gB8D5s',
    description: 'Link text to learn more about inventory management',
  },
  setupButton: {
    defaultMessage: 'Setup Inventory in ShipStation',
    id: '9uxzGX',
    description: 'Button text to setup inventory in ShipStation',
  },
  illustrationAlt: {
    defaultMessage: 'ShipStation inventory management illustration',
    id: 'h460ph',
    description: 'Alt text for the inventory management illustration',
  },
});
